<div class="section-top">
  <div class="section-top__header layout-space-between">
    <!-- Left Column -->
    <div class="section-top__header-left">
      <button qa="creationButton"
        nz-button
        nzType="text"
        (click)="onCreateEndpointButtonClickHandler()"
      >
        {{ titleSide }}
        <span nz-icon nzType="ng-zorro:buttonAdd"></span>
      </button>
    </div>

    <!-- Right Column -->
    <div class="section-top__header-right">
      <label class="section-top__toggle">
        <span class="section-top__toggle-label">{{ titleView }}</span>
        <nz-switch
          [attr.switchLabel]="getSwitchLabel(side)"
          (ngModelChange)="onChangeToggleHandler($event)"
          [(ngModel)]="isActive"
        ></nz-switch>
      </label>
      <app-column-option-drop
        iconClass="icomoon icomoon_ic_columns"
        multi="multi"
        [side]="side"
        [items]="builderItems"
        [tableHeight]="tableHeight"
        (optionChanged)="onOptionChangeHandler($event)"
      ></app-column-option-drop>
      <button
        [attr.buttonLabel]="getButtonLabel(side)"
        class="section-top__action-btn"
        (click)="onDownloadHandler()"
      >
        <span nz-icon nzType="ng-zorro:download"></span>
      </button>
      <button class="section-top__action-btn" (click)="onExpandTableHandler()">
        <span nz-icon nzType="ng-zorro:expand"></span>
      </button>
    </div>
  </div>

  <div class="section-top__controls">
    <div class="section-top__search">
      <nz-input-group [nzPrefix]="search">
        <input
          nz-input
          type="text"
          [placeholder]="titleView"
          [(ngModel)]="filterVal"
          (input)="onSearchHandler($event, true)"
        />
      </nz-input-group>
      <ng-template #search>
        <i nz-icon nzType="search"></i>
      </ng-template>
    </div>
    <div class="section-top__dropdown">
      <nz-select
        style="width: 100%"
        nzShowSearch
        [(ngModel)]="selectedActivity"
        (ngModelChange)="onChangeActivityHandler($event)"
      >
        <nz-option
          *ngFor="let item of activityItems"
          [nzLabel]="item.name"
          [nzValue]="item.id"
        >
        </nz-option>
      </nz-select>
    </div>
    <div class="section-top__dropdown">
      <app-select-tree-main
        (changeSelect)="onChangeFilterHandler($event)"
        [tableHeight]="heightContent"
        [filters]="filterItems"
        [side]="side"
      >
      </app-select-tree-main>
    </div>
  </div>
</div>
